<template>

  <font-awesome-layers fixed-width>
    <font-awesome-icon icon="clipboard" :size="size"></font-awesome-icon>
    <font-awesome-icon icon="wrench" :size="size" inverse transform="shrink-10 down-2"></font-awesome-icon>
  </font-awesome-layers>

</template>

<script>
export default {
  name: 'icon-issue',
  props: [ 'size' ]
}
</script>

<style scoped lang="scss">

</style>
